import { Tracking } from '@/Domain/Tracking/Tracking'
import { LumberjackDTO } from './LumberjackDTO'

export class TrackingDTO {
  private _orde: string
  private _barchId: string
  private _recordId: string
  private _fase: string
  private _isolatesMode: string
  private _mountain: string
  private _owner: string
  private _location: string
  private _surface: string
  private _taxes: string
  private _lumberjack: LumberjackDTO[]

  static fromtracking (tracking: Tracking): TrackingDTO {
    const lumberjackDTO: LumberjackDTO[] = []
    for (const trac of tracking.lumberjack()) {
      lumberjackDTO.push(LumberjackDTO.fromLumberjack(trac))
    }

    const orde = tracking.orde() === null ? '' : tracking.orde() + ''

    return new this(
      orde,
      tracking.batchId(),
      tracking.recordId(),
      tracking.fase(),
      tracking.isolatesMode(),
      tracking.mountain(),
      tracking.owner(),
      tracking.location(),
      tracking.surface(),
      tracking.taxes(),
      lumberjackDTO
    )
  }

  constructor (
    orde: string,
    batchId: string,
    recordId: string,
    fase: string,
    isolatesMode: string,
    mountain: string,
    owner: string,
    location: string,
    surface: string,
    taxes: string,
    lumberjack: LumberjackDTO []
  ) {
    this._orde = orde
    this._barchId = batchId
    this._recordId = recordId
    this._fase = fase
    this._isolatesMode = isolatesMode
    this._mountain = mountain
    this._owner = owner
    this._location = location
    this._surface = surface
    this._taxes = taxes
    this._lumberjack = lumberjack || []
  }

  get orde (): string {
    return this._orde
  }

  get batchId (): string {
    return this._barchId
  }

  get recordId (): string {
    return this._recordId
  }

  get fase (): string {
    return this._fase
  }

  get isolatesMode (): string {
    return this._isolatesMode
  }

  get mountain (): string {
    return this._mountain
  }

  get owner (): string {
    return this._owner
  }

  get location (): string {
    return this._location
  }

  get surface (): string {
    return this._surface
  }

  get taxes (): string {
    return this._taxes
  }

  get lumberjack (): LumberjackDTO[] {
    return this._lumberjack
  }
}
